import source from './Ranking.json';
let data = source.filter((rest)=>rest.key!=='zzz');
export default data;
